import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {useString} from '../../../utils/string'
import {getUsedMyRefCode} from '../../../apis/user/getUsedMyRefCode'

const useQueryGetUsedMyRefCode = (id?: string) => {
    const {isNotEmpty} = useString()

    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.user.getUsedMyRefCode(id),
        queryFn: async () => {
            const {data} = await getUsedMyRefCode(id)
            return data
        },
        refetchOnWindowFocus: false,
        enabled: !!id,
    })

    return {data, refetch, isLoading}
}

export default useQueryGetUsedMyRefCode
